import type { HttpTransport } from '@mangovoice/api-client'

/**
 * Music on Hold resource - delegates to the @mangovoice/music-on-hold-ui library
 * for actual endpoint definitions. This provides a pass-through transport adapter.
 */
export function createMusicOnHoldResource(transport: HttpTransport) {
  return {
    get: <T>(url: string, params?: Record<string, unknown>) =>
      transport.get<T>(url, params),

    post: <T>(
      url: string,
      data?: unknown,
      config?: { headers?: Record<string, string> },
    ) => transport.post<T>(url, data, config),

    patch: <T>(
      url: string,
      data?: unknown,
      config?: { headers?: Record<string, string> },
    ) => transport.patch<T>(url, data, config),

    put: <T>(
      url: string,
      data?: unknown,
      config?: { headers?: Record<string, string> },
    ) => transport.put<T>(url, data, config),

    delete: <T>(url: string) => transport.delete<T>(url),
  }
}
